(function (app, ng) {

    app.controller("shareReportController", shareReportController);

    shareReportController.$inject = ["_", "$q", "$rootScope", "$mdDialog", "reportApi", "userApi"];
    function shareReportController(_, $q, $rootScope, $mdDialog, reportApi, userApi) {
        var $ctrl = this;

        ng.extend($ctrl,
            {
                ui: {
                },
                unsaved: false,
                initReport: ng.copy($ctrl.report),
                public: $ctrl.report.IsPublic,
                usersToAdd: [],
                usersToRemove: [],
                close: close,
                searchUsers: searchUsers,
                addUser: addUser,
                removeUser: removeUser,
                save: save
            });

        function close() { $mdDialog.hide(); }

        function searchUsers(term) {
            return userApi.searchUsers(term).then(function (result) {
                result = _.reject(result,
                    function (row) {
                        return _.find($ctrl.report.SharedWith,
                            function (sharedWith) {
                                return sharedWith.UserId === row.Id;
                            });
                    });

                ng.forEach(result,
                    function (row) {
                        return row.Term = row.FirstName + " " + row.LastName;
                    });

                return result;
            });

        }

        function addUser(user) {
            if (user && user.Id) {
                $ctrl.usersToAdd.push(user);
                $ctrl.report.SharedWith.push({
                    ReportId: $ctrl.report.Id,
                    UserId: user.Id,
                    User: user
                });
                $ctrl.ui.userText = "";
                $ctrl.selectedUser = "";

                $ctrl.unsaved = true;    
            }
        }

        function removeUser(sharedWith) {
            var removed = _.remove($ctrl.usersToAdd,
                function (u) {
                    return u.Id === sharedWith.UserId;
                })[0];

            if (!removed) {
                $ctrl.usersToRemove.push(sharedWith);
            }

            _.remove($ctrl.report.SharedWith,
                function (sW) {
                    return sW.UserId === sharedWith.UserId;
                });

            $ctrl.unsaved = $ctrl.public !== $ctrl.report.public ||
                $ctrl.usersToAdd.length > 0 ||
                $ctrl.usersToRemove.length > 0;
        }

        function save() {
            $ctrl.ui.saving = true;
            var promises = [];

            if ($ctrl.public !== $ctrl.report.IsPublic) {
                $ctrl.report.IsPublic = $ctrl.public;
                promises.push(reportApi["update" + $ctrl.report.Type + "Report"]($ctrl.report.Id, $ctrl.report));
            }

            if (!$ctrl.report.IsPublic && ($ctrl.usersToAdd.length > 0 || $ctrl.usersToRemove.length > 0)) {

                ng.forEach($ctrl.usersToAdd,
                    function (user) {
                        promises.push(reportApi.createSharedReport(user.Id, $ctrl.report.Id).then(function (response) {
                            var sharedWith = _.find($ctrl.report.SharedWith,
                                function (sW) {
                                    return sW.UserId === user.Id;
                                });

                            sharedWith.SharedReportId = response.Id;
                        }));
                    });

                ng.forEach($ctrl.usersToRemove,
                    function (sharedWith) {
                        promises.push(reportApi.deleteSharedReport(sharedWith.SharedReportId));
                    });
            }

            $q.all(promises).then(function () {
                $ctrl.ui.saving = false;
                $ctrl.usersToAdd = [];
                $ctrl.usersToRemove = [];
                $ctrl.unsaved = false;
                $ctrl.report.Visibility = $ctrl.report.IsPublic ? "Public" : $ctrl.report.SharedWith.length > 0 ? "Individuals" : "Private";

                $rootScope.$broadcast("sharedWithUpdated", $ctrl.report);
            });
        }
    }
})(window.app, window.angular); //jshint: ignore:line